import {Injectable} from "@angular/core";
import {ActivatedRouteSnapshot, Resolve, RouterStateSnapshot} from "@angular/router";
import {Observable} from "rxjs";
import {BackupService} from './backup.service';
import {Backup} from './backup';
import {ProductService} from "../product.service";
import * as fromStore from "../../../store";
import {Store} from "@ngrx/store";
import {filter, switchMap} from "rxjs/operators";
import {Job} from "./job";
import {TypeUtils} from "../../../shared/utils/type-utils";
import {combineLatest} from 'rxjs';


@Injectable()
export class BackupsResolver implements Resolve<Backup[]|null> {

  constructor(
    private _backupService: BackupService,
    private _productService: ProductService,
    private _store: Store<fromStore.DbStoreState>
  ) {}

  resolve(route: ActivatedRouteSnapshot, state: RouterStateSnapshot): Observable<any>|Promise<any>|any {
    return new Promise((resolve: Function, reject: Function): void => {
      const websiteId: number = route.parent.data['website'].id;
      const _childWebsiteId = route.parent.data['website'].isNetwork && !route.parent.data['website'].parentId && route.parent.data['website'].children && route.parent.data['website'].children.length ? route.parent.data['website'].children[0] : null;
      this._store.select(fromStore.getWebsitePluginsLoaded(_childWebsiteId || websiteId))
        .pipe(
          filter((loaded: boolean) => loaded),
          switchMap(() => this._store.select(fromStore.getWebsiteBackupPlugin(_childWebsiteId || websiteId)))
        )
        .subscribe((backupPlugin) => {
          if (backupPlugin && backupPlugin.active && backupPlugin.paidVersionInstalled) {
            this._store.select(fromStore.getWebsiteBackupLoaded(_childWebsiteId || websiteId))
              .pipe(
                filter((loaded: boolean) => loaded),
                switchMap(() => {
                  return combineLatest(
                    this._store.select(fromStore.getWebsiteBackup(_childWebsiteId || websiteId)),
                    this._store.select(fromStore.getWebsiteJob(_childWebsiteId || websiteId))
                  );
                })
              )
              .subscribe((value: [Backup[], Job ]) => {
                if (value[0].length && !TypeUtils.isEmpty(value[1])) {
                  resolve(value);
                }
                else {
                  resolve(null);
                }
              });
          }
          else {
            resolve(null);
          }
        });
    });
  }

}
